import LZString from "lz-string";

const COMPRESSED_PREFIX = "lz:";

export const setCompressedSessionItem = (key, value) => {
  try {
    const compressedValue = LZString.compressToBase64(JSON.stringify(value));
    sessionStorage.setItem(key, `${COMPRESSED_PREFIX}${compressedValue}`);
  } catch (error) {
    sessionStorage.removeItem(key);
    console.warn(`Unable to cache ${key} in sessionStorage`, error);
  }
};

export const getCompressedSessionItem = (key) => {
  const storedValue = sessionStorage.getItem(key);

  if (!storedValue) {
    return null;
  }

  try {
    if (storedValue.startsWith(COMPRESSED_PREFIX)) {
      const decompressedValue = LZString.decompressFromBase64(
        storedValue.slice(COMPRESSED_PREFIX.length)
      );

      return decompressedValue ? JSON.parse(decompressedValue) : null;
    }

    return JSON.parse(storedValue);
  } catch (error) {
    console.warn(`Unable to read ${key} from sessionStorage`, error);
    return null;
  }
};
